module.exports = __webpack_public_path__ + "img/download.08a0498e.png";